import type { Dayjs } from 'dayjs';
import * as Yup from 'yup';

import { ISelectModelCode } from 'common/models';

export const BasicInformationValidationSchema = Yup.object().shape({
  term: Yup.string().trim().required('Required'),
  partner: Yup.string().nullable(),
  calculationStatus: Yup.string().required('Required'),
  date: Yup.string().required('Required'),
  serviceId: Yup.string().required('Required'),
  languageId: Yup.string().required('Required'),
  currencyId: Yup.string().required('Required'),
  adults: Yup.number().required('Required'),
});

export type RangeValue = [Dayjs | null, Dayjs | null] | null;
export interface IBasicInformation {
  term: string;
  partner: string;
  calculationStatus: string;
  date: RangeValue[];
  serviceId: number | string;
  languageId: string;
  currencyId: string | number;
  adults: number;
  teens: number;
  children: number;
  babies: number;
}

export type TBasicInformationTableState = {
  isModalVisible: boolean;
  tableData: IReservationObjectData[];
  formValues: IBasicInformation;
  isStepOneFormDirty: boolean;
};

export interface IReservationObjectData {
  cityId: number;
  cityName: string;
  imageUrl: string;
  latitude: number;
  longitude: number;
  propertyAddress: string;
  propertyCode: string;
  propertyId: string;
  propertyName: string;
  units: TUnits[];
}

export type TUnits = {
  propertyCode: string;
  propertyName: string;
  unitCode: string;
  unitId: string;
  unitName: string;
  unitQuantity: number;
  unitTypeId: number;
  minGuest: number;
  maxGuest: number;
  residentialTax: number;
  imageUrl: string;
  calculationStatus: number;
  datePublished: string;
  dateCreated: string;
  checked: boolean;
};

export interface IReservationStatus extends ISelectModelCode<string> {
  rootId: string;
}
